'use client';

import React from 'react';

interface TocItem {
    id: string;
    text: string;
    tagName: string;
}

interface PostTocProps {
    tocItems: TocItem[];
    className?: string;
}

const PostToc: React.FC<PostTocProps> = ({ tocItems, className }) => {
    const handleClick = (id: string) => {
        if (typeof window !== 'undefined') {
            const el = document.getElementById(id);
            if (el) {
                // Lets a collapsed article (CollapsibleContent) open before we scroll to the heading
                el.dispatchEvent(new CustomEvent('reveal', { bubbles: true }));
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                history.replaceState(null, '', window.location.pathname);
            }
        }
    };

    return (
        <nav className={className}>
            <div className='font-bold flex justify-between items-center cursor-pointer'>
                فهرست مطالب
            </div>
            <ul
                className='mb-3 max-h-[36vh] pb-5 list-none space-y-2 overflow-y-auto p-3 pr-2 text-right no-scrollbar'
                dir='rtl'
            >
                {tocItems.map((item) => (
                    <li
                        key={item.id}
                        className={`text-xs flex items-start gap-2 text-primary-dark/70 dark:text-white/70 ${item.tagName === 'H3' ? 'mr-5' : ''}`}
                    >
                        {item.tagName === 'H3' && (
                            <span className='text-xxs text-primary/50 dark:text-white/40'>
                                &#9632;
                            </span>
                        )}
                        <button
                            className='text-right bg-transparent p-0 m-0 border-0 cursor-pointer'
                            onClick={() => handleClick(item.id)}
                        >
                            {item.text}
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default PostToc;
